import { BulkActionsVariant, BulkEntityActionItem } from "components/BulkActions/types";
import { RunPriorityPreset, RunWithPosition } from "types/generated";

export enum BulkWorkerPoolQueuedRunsActions {
  HIGH_PRIORITY = "High priority",
  NORMAL_PRIORITY = "Normal priority",
  LOW_PRIORITY = "Low priority",
  DISCARD = "Discard",
}

export const BULK_ACTION_PER_PRIORITY_PRESET: Record<
  RunPriorityPreset,
  BulkWorkerPoolQueuedRunsActions
> = {
  [RunPriorityPreset.High]: BulkWorkerPoolQueuedRunsActions.HIGH_PRIORITY,
  [RunPriorityPreset.Normal]: BulkWorkerPoolQueuedRunsActions.NORMAL_PRIORITY,
  [RunPriorityPreset.Low]: BulkWorkerPoolQueuedRunsActions.LOW_PRIORITY,
};

export type WorkerPoolQueuedRunsBulkActionsAnalyticsPayload = {
  view: BulkActionsVariant;
};

export type BulkItemRunWithPosition = RunWithPosition & {
  id: string;
};

export type WorkerPoolQueuedRunsBulkActionsSelectedAction = BulkEntityActionItem<
  BulkWorkerPoolQueuedRunsActions,
  BulkItemRunWithPosition,
  undefined
>;
